<template>
  <div class="divWrap" >
    <div class="divLogin">
      <div class="left-back"></div>
      <div class="right-login">
        <div class="content">
          <div class="divTitle">问答管理系统</div>
          <div class="signature">欢迎登录</div>
          <el-form :model="loginForm" label-width="0px" class="divContent">
            <el-form-item style="margin-right:0;">
              <el-input
                v-model="loginForm.sAccountNum"
                tabindex="1" id="username"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                maxlength="32"
              >
              </el-input>
            </el-form-item>
            <el-form-item  style="margin-right:0;">
              <el-input
                type="password"
                tabindex="2"
                placeholder="请输入密码"
                v-model="loginForm.sPassword"
                id="password" @keyup.enter.native="doLogin"
                prefix-icon="el-icon-lock"
                maxlength="16"
              >
              </el-input>
            </el-form-item>
            <div class="btnLogin">
              <el-button type="primary" round @click="doLogin">登录</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
// import { getManageList} from '@/api/common'
// import md5 from 'js-md5'

import { logIn } from '@/api/common'
export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        sAccountNum: '',
        sPassword: '',
        sLoginType: 'WEB'
      }
    }
  },
  mounted: function () {
    $('#username').focus()
  },
  methods: {
    doLogin: function () {
      // 必须输入账号
      if (this.loginForm.sAccountNum === '') {
        this.$notify({
          title: '提示',
          message: '操作提示：请输入账号！',
          type: 'warning'
        })
        $('#username').focus()
        return
      }
      // 必须输入密码
      if (this.loginForm.sPassword === '') {
        this.$notify({
          title: '提示',
          message: '操作提示：请输入密码！',
          type: 'warning'
        })
        $('#password').focus()
        return
      }

      // console.log(this.loginForm.sPassword)
      // this.loginForm.sPassword = md5(this.loginForm.sPassword.trim())
      this.loginForm.sPassword = this.loginForm.sPassword.trim()
      // console.log(this.loginForm.sPassword)
      // 验证用户名密码
      let url = '/logIn'
      let params = {
        userCount: this.loginForm.sAccountNum,
        userPasswd: this.loginForm.sPassword
      }
      logIn(url, params).then(response => {
        // console.log('登陆' + JSON.stringify(response))
        if (response.data.ret !== 1) {
          this.$notify({
            title: '提示',
            message: response.data.message,
            type: 'warning'
          })
        } else {
          localStorage.setItem('userId', response.data.content.userId)
          localStorage.setItem('userType', response.data.content.userType)
          localStorage.setItem('userName', response.data.content.userName)
          localStorage.setItem('userCount', response.data.content.userCount)
          sessionStorage.setItem('token', response.data.content.token)

          // localStorage.setItem('userType', 'adminUser')
          // if (true) {
          if (response.data.content.userType === 'adminUser') {
            this.$router.push({
              name: 'questionRecord'
            })
          } else {
            this.$router.push({
              name: 'PersonSend'
            })
          }
        }
        // localStorage.setItem('sUserId', sUserId)
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '登录失败',
          type: 'warning'
        })
      })
    },
    routerGO (sUserId) {
      // let url = 'Authority/getUserAuthority'
      // let params = {'sUserId': sUserId}
      // getManageList(url, params).then(response => {
      //   var data = response.data.content
      //   let a1 = false
      //   let a2 = false
      //   let a3 = false
      //   let a4 = false
      //   for (let i = 0; i < data.length; i++) {
      //     if (data[i].sAuthId === '00000010') {
      //       a1 = true
      //     } else if (data[i].sAuthId === '00000007') {
      //       a2 = true
      //     } else if (data[i].sAuthId === '00000013' || data[i].sAuthId === '00000006') {
      //       a3 = true
      //     } else if (data[i].sAuthId === '00000016') {
      //       a4 = true
      //     }
      //   }
      //   if (a1 == true) {
      //     this.$router.push({name: 'PersonSend'})
      //     return
      //   }
      //   if (a2 == true) {
      //     this.$router.push({name: 'meeting'})
      //     return
      //   }
      //   if (a3 == true) {
      //     this.$router.push({name: 'VisitsPage'})
      //     return
      //   }
      //   if (a4 == true) {
      //     this.$router.push({name: 'appointment'})
      //   }
      // }).catch(response => {
      //   this.showExceptionMessage()
      // })
    },
    showSuccessMessage: function (keyWord) {
      this.$notify({
        title: '提示',
        message: keyWord,
        type: 'success'
      })
    },
    showFailureMessage: function (keyWord) {
      this.$notify({
        title: '提示',
        message: keyWord,
        type: 'warning'
      })
    },
    showExceptionMessage: function () {
      this.$notify({
        title: '提示',
        message: '系统异常：请联系管理员！',
        type: 'error'
      })
    }
  }
}
</script>

<style scoped>

  .divWrap{
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: 100% 100% !important;
    background: linear-gradient(#7db4ff, #2c77ea);
    /*background-img: url();*/
  }
  .signature{
    margin-top: 10px;
    color: #b0b0b0;
    font-size: 18px;
    text-align: left;
  }
  .divTitle{
    width: 100%;
    line-height: 50px;
    text-align: left;
    font-size: 36px;
    color: #2c77ea;
    /*border-bottom: 1px solid #ddd;*/
  }
  .divLogin{
    margin: 8.5vh 5vw;
    width: 90vw;
    height: 83vh;
    border-radius: 20px;
    overflow: hidden;
  }
  .divContent{
    /*padding: 30px 30px;*/
    width: 30vw;
    margin-top: 8vh;
  }
  .content{
    margin: 19vh 7.3vw;
  }
  .right-login{
    width: 50%;
    height: inherit;
    float: right;
    position: relative;
    background-color: #fff;
  }
  .right-login::after{
    content: url("~@/assets/common/loginLight.png");
    position: absolute;
    top: 0;
    left: 80%;
  }
  .left-back{
    width: 50%;
    height: inherit;
    background-color: #2c77ea;
    float: left;
    background-image: url("~@/assets/common/loginBakc.png");
    background-size: 100% 100%;
  }
  .btnLogin{
    margin-top: 9vh;
    text-align: center;
  }
  .btnLogin button{
    width: 100%;
  }
  >>> .el-icon-user{
    color: #2c77ea;
  }
  >>> .el-icon-lock{
    color: #2c77ea;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/login.vue